import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "circularBg", "className", "iconStart", "variant", "iconEnd", "onClick", "templateId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React from 'react';
import { getLinkTarget } from '@mirohq-internal/website-utils';
import { Icons } from '../icons/icons';
import { useTemplateLoader } from '../template-loader/template-loader';
import { LinkBase } from './link-base/link-base';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Anchor = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      circularBg = _ref.circularBg,
      className = _ref.className,
      iconStart = _ref.iconStart,
      variant = _ref.variant,
      iconEnd = _ref.iconEnd,
      _onClick = _ref.onClick,
      templateId = _ref.templateId,
      rest = _objectWithoutProperties(_ref, _excluded);

  /**
   * Only non fixed width links can have start icons
   */
  var StartIcon = Icons === null || Icons === void 0 ? void 0 : Icons["".concat(iconStart)];
  var EndIcon = Icons === null || Icons === void 0 ? void 0 : Icons["".concat(iconEnd)];

  var _useTemplateLoader = useTemplateLoader(),
      setSelectedTemplate = _useTemplateLoader.setSelectedTemplate;

  return /*#__PURE__*/_jsxs(LinkBase, _objectSpread(_objectSpread({
    ref: ref,
    variant: variant || 'anchor',
    target: getLinkTarget(rest.href || ''),
    onClick: function onClick(event) {
      if (templateId) {
        /**
         * If `templateId` is specified, we will override the default behaviour
         * of the click handler in order to trigger the account picker
         *
         * TODO: Move this to the Cta module
         */
        event.preventDefault();
        setSelectedTemplate({
          metadataId: templateId
        });
        return;
      }

      _onClick === null || _onClick === void 0 ? void 0 : _onClick(event);
    },
    className: classNames(className, {
      'link-anchor-circular-bg': circularBg
    })
  }, rest), {}, {
    children: [StartIcon && /*#__PURE__*/_jsx(StartIcon, {
      size: (rest === null || rest === void 0 ? void 0 : rest.size) || 'inherit'
    }), children && /*#__PURE__*/_jsx("span", {
      className: "d-inline-block text-truncate",
      children: children
    }), EndIcon && /*#__PURE__*/_jsx(EndIcon, {
      size: (rest === null || rest === void 0 ? void 0 : rest.size) || 'inherit'
    })]
  }));
});